import { Device } from '@hc-frontend/core-types';

export function getDeviceByViewportWidth() {
  const viewportWidth = window.screen.availWidth;

  if (viewportWidth < 720) {
    return Device.enum.MOBILE;
  }

  if (viewportWidth < 1024) {
    return Device.enum.TABLET;
  }

  return Device.enum.DESKTOP;
}
